import { render, staticRenderFns } from "./LeadsProductGrid.vue?vue&type=template&id=c3972bd6&scoped=true"
import script from "./LeadsProductGrid.vue?vue&type=script&lang=ts"
export * from "./LeadsProductGrid.vue?vue&type=script&lang=ts"
import style0 from "./LeadsProductGrid.vue?vue&type=style&index=0&id=c3972bd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3972bd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3972bd6')) {
      api.createRecord('c3972bd6', component.options)
    } else {
      api.reload('c3972bd6', component.options)
    }
    module.hot.accept("./LeadsProductGrid.vue?vue&type=template&id=c3972bd6&scoped=true", function () {
      api.rerender('c3972bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leads/components/LeadsProductGrid.vue"
export default component.exports